import React from 'react'
import styled from '@emotion/styled'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {cssTheme} from '@vio/atlas/themes'

import {BOVIO_FIRST_CARD_IMAGE_HEIGHT} from '../HotelCardGallery/BoVioFirstCardGallery'

const MAX_HOTEL_CARD_WIDTH = 615

interface Props {
  gallerySlot: React.ReactNode
  galleryButtonSlot: React.ReactNode
  propertyDetailsSlot: React.ReactNode
  offerSlot: React.ReactNode
  priceWatchSlot?: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
  isAnchor?: boolean
  isOTAMode?: boolean
}

const Container = styled.div`
  border: 1px solid;
  border-color: ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;
  max-width: ${MAX_HOTEL_CARD_WIDTH}px;

  &.--anchor-hotel {
    outline-width: ${cssTheme.layout.spacing.s100};
    outline-offset: -1px;
    outline-style: solid;
    outline-color: ${cssTheme.colors.hotelCard.special.border};
  }
`
export const BoVioFirstCardLayout = ({
  propertyDetailsSlot,
  offerSlot,
  gallerySlot,
  galleryButtonSlot,
  priceWatchSlot,
  onClick,
  isAnchor,
  isOTAMode = false
}: Props) => {
  // data-bovio-first-card: identify this card in the DOM for debugging (vs ComposedHotelCard)
  return (
    <Container
      className={isAnchor && '--anchor-hotel'}
      data-bovio-first-card="true"
    >
      <Box
        position="relative"
        height={`${BOVIO_FIRST_CARD_IMAGE_HEIGHT}px`}
        overflow="hidden"
      >
        {gallerySlot}
        <Box
          position="absolute"
          top={cssTheme.layout.spacing.s300}
          right={cssTheme.layout.spacing.s300}
        >
          {galleryButtonSlot}
        </Box>
      </Box>
      <Box onClick={onClick}>{propertyDetailsSlot}</Box>
      {!isOTAMode && <Divider />}
      {offerSlot}
      {priceWatchSlot}
    </Container>
  )
}
